import React from "react";
import "react-day-picker/lib/style.css";
import { transformToHtml } from "../../../utils/CommonUtils";
import DatePickerWrapper from "./DatePickerWrapper";

function formatDate(dateStr) {
  if (!dateStr) return "";
  try {
    return new Date(dateStr).toLocaleDateString("en-IN", {
      weekday: "short",
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  } catch {
    return dateStr;
  }
}

function getSelectedDate(value) {
  if (!value) return new Date();
  try {
    return new Date(value);
  } catch {
    return new Date();
  }
}

export default function DateField({
  value,
  placeholder,
  fieldConfig,
  isOpen,
  onOpen,
  onClose,
  onChange,
  isOutsideAllowedRange,
}) {
  return (
    <div className="fs-header__field">
      {fieldConfig?.label && (
        <div className="fs-header__field-label fontSize12">
          {transformToHtml(fieldConfig.label)}
        </div>
      )}
      <button
        className="fs-header__field-input fs-header__field-input--datepicker fontSize14"
        type="button"
        onClick={onOpen}
        aria-label={fieldConfig?.label || "Select date"}
      >
        <span>{value ? formatDate(value) : fieldConfig?.placeHolder || placeholder}</span>
      </button>
      {isOpen && (
        <>
          <div className="fs-overlayBg" onClick={onClose} />
          <div className="datePickerContainer">
            <div className="dayPickerFlightWrap depart-cal">
              <DatePickerWrapper
                selectedDays={getSelectedDate(value)}
                disabledDays={isOutsideAllowedRange}
                onDayClick={(day, modifiers) => {
                  if (day && !modifiers?.disabled) {
                    onChange && onChange(day, modifiers);
                  }
                }}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
}
